class MainSearch extends SearchForm {
  constructor() {
    super();
    this.allSearchInputs = document.querySelectorAll('input[type="search"]');
    this.setupEventListeners();
  }

  setupEventListeners() {
    let allSearchForms = [];
    this.allSearchInputs.forEach((input) => allSearchForms.push(input.form));
    this.input.addEventListener('focus', this.onInputFocus.bind(this));
    if (allSearchForms.length < 2) return;
    allSearchForms.forEach((form) => form.addEventListener('reset', this.onFormReset.bind(this)));
    this.allSearchInputs.forEach((input) => input.addEventListener('input', this.onInput.bind(this)));
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.keepInSync('', this.input);
    }
  }

  onInput(event) {
    const target = event.target;
    this.keepInSync(target.value, target);
  }

  onInputFocus() {
    const isSmallScreen = window.innerWidth < 750;
    if (isSmallScreen) {
      this.scrollIntoView({ behavior: 'smooth' });
    }
  }

  keepInSync(value, target) {
    this.allSearchInputs.forEach((input) => {
      if (input !== target) {
        input.value = value;
      }
    });
  }
}

customElements.define('main-search', MainSearch);

class SearchInfiniteScroll extends HTMLElement {
  connectedCallback() {
    if (this.observer) return;

    this.loading = false;
    this.abortController = new AbortController();
    this.observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) this.loadNextPage();
      },
      { rootMargin: '900px 0px' },
    );
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    this.abortController?.abort();
  }

  async loadNextPage() {
    if (this.loading || !this.dataset.nextUrl) return;

    this.loading = true;
    const nextUrl = new URL(this.dataset.nextUrl, window.location.origin);
    if (this.dataset.sectionId) nextUrl.searchParams.set('section_id', this.dataset.sectionId);

    try {
      const response = await fetch(nextUrl.toString(), {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        signal: this.abortController.signal,
      });
      if (!response.ok) throw new Error('Search pagination request failed');

      const parsedHtml = new DOMParser().parseFromString(await response.text(), 'text/html');
      const nextGrid = parsedHtml.querySelector('#ProductGridContainer #product-grid .product-grid');
      const currentGrid = this.closest('#product-grid')?.querySelector('.product-grid');
      if (!nextGrid || !currentGrid) throw new Error('Search pagination grid was not found');

      const fragment = document.createDocumentFragment();
      nextGrid.querySelectorAll(':scope > .grid__item').forEach((item) => {
        item.classList.remove('scroll-trigger', 'animate--slide-in', 'scroll-trigger--offscreen');
        item.removeAttribute('data-cascade');
        item.style.removeProperty('--animation-order');
        fragment.appendChild(item);
      });
      currentGrid.appendChild(fragment);

      const nextSentinel = parsedHtml.querySelector('search-infinite-scroll[data-next-url]');
      if (nextSentinel?.dataset.nextUrl) {
        this.dataset.nextUrl = nextSentinel.dataset.nextUrl;
        this.loading = false;

      } else {
        this.remove();
      }
    } catch (error) {
      if (error.name === 'AbortError') return;
      console.error(error);
      this.loading = false;
      this.dataset.loadFailed = 'true';
    }
  }
}

if (!customElements.get('search-infinite-scroll')) {
  customElements.define('search-infinite-scroll', SearchInfiniteScroll);
}
